import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { 
  BsCameraVideo, 
  BsBroadcast,
  BsMic
} from 'react-icons/bs';
import './events.css';
import DashboardHeader from '../../../components/DashboardHeader';
import DashboardFooter from '../../../components/DashboardFooter';
import { auth, db } from '../../../auth/firebase';
import { doc, updateDoc } from 'firebase/firestore';
import cacheManager from '../../../auth/cache_manager';

function Events() {
  const navigate = useNavigate();
  const [isDarkMode, setIsDarkMode] = useState(false);

  // # Load theme preference from user data on initial render
  useEffect(() => {
    const loadThemePreference = async () => {
      if (auth.currentUser?.uid) {
        // # Try to get from cache first
        const userData = cacheManager.get(`user_${auth.currentUser.uid}`);
        if (userData && userData.themes && userData.themes.gen_theme !== undefined) {
          setIsDarkMode(userData.themes.gen_theme === 'dark');
        }
      }
    };
    
    loadThemePreference();
  }, []);

  // # Handle theme toggle
  const handleThemeToggle = async () => {
    try {
      const newTheme = !isDarkMode;
      setIsDarkMode(newTheme);
      
      // # Update theme in Firebase if user is logged in
      if (auth.currentUser?.uid) {
        // # Update the user document
        await updateDoc(doc(db, 'users', auth.currentUser.uid), {
          'themes.gen_theme': newTheme ? 'dark' : 'light'
        });
        
        // # Update cache manager
        const userData = cacheManager.get(`user_${auth.currentUser.uid}`);
        if (userData) {
          const updatedUserData = {
            ...userData,
            themes: {
              ...(userData.themes || {}),
              gen_theme: newTheme ? 'dark' : 'light'
            }
          };
          cacheManager.set(`user_${auth.currentUser.uid}`, updatedUserData);
        }
      }
    } catch (error) {
      console.error('Error updating theme preference:', error);
    }
  };

  // # Define events sections with icons and descriptions
  const eventSections = [
    {
      title: "Community Meetings",
      icon: <BsCameraVideo className="evt_section-icon" />,
      description: 'Join our interactive community meetings and discussions',
      isReady: true,
      link: '/community/events/meetings'
    },
    {
      title: 'Lives',
      icon: <BsBroadcast className="evt_section-icon" />,
      description: 'Watch live sessions with medical professionals',
      isReady: false
    },
    {
      title: 'Podcasts',
      icon: <BsMic className="evt_section-icon" />,
      description: 'Listen to medical education podcasts',
      isReady: false
    }
  ];

  return (
    <div className={`evt_page-container ${isDarkMode ? 'evt_dark-mode' : ''}`}>
      <DashboardHeader isDarkMode={isDarkMode} onThemeToggle={handleThemeToggle} />
      
      <main className="evt_main-content">
        <div className="evt_header">
          <h1>Events</h1>
          <p>Stay connected with our medical community through various events</p>
        </div>

        <div className="evt_sections-grid">
          {eventSections.map((section, index) => (
            <div 
              key={index}
              className={`evt_section-card ${section.isReady ? 'clickable' : ''}`}
              onClick={() => section.isReady && section.link && navigate(section.link)}
            >
              <div className="evt_icon-container">
                {section.icon}
              </div>
              <h3>{section.title}</h3>
              <p>{section.description}</p>
              {!section.isReady && (
                <div className="evt_coming-soon">Coming Soon</div>
              )}
            </div>
          ))}
        </div>
      </main>

      <DashboardFooter isDarkMode={isDarkMode} />
    </div>
  );
}

export default Events;




